module.exports = "mutation ($data: [CommentCreate!]!) {\n  CommentsCreate(data: $data) {\n    id\n  }\n}\n"